export const ACTIONS = require("./actions")
export const ENDPOINTS = require("./endpoints")

// filters
export const IS_DELETED_INIT_VALUE = 0
export const IS_DELETED = "is_deleted"
